import { render, staticRenderFns } from "./minhas-turmas.vue?vue&type=template&id=19a01cf1&"
import script from "./minhas-turmas.vue?vue&type=script&lang=js&"
export * from "./minhas-turmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports